import angular from 'angular';
import { OrderSummarySummaryCardComponent } from './order-summary-summary-card/order-summary-summary-card.component';
import { OrderSummaryCourierRowComponent } from './order-summary-courier-row/order-summary-courier-row.component';

angular
  .module('app.global.order-summary', [])
  .component('orderSummarySummaryCard', OrderSummarySummaryCardComponent)
  .component('orderSummaryCourierRow', OrderSummaryCourierRowComponent);
